import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CaDesignModule } from '../../ca-design/ca-design.module';

export interface AiSuggestionFieldOptions {
  title: string;
  value: string | null;
}

export interface AiSuggestionDialogData {
  fields?: AiSuggestionFieldOptions[];
  loading?: boolean | null;
  error?: string | null;
}

@Component({
  selector: 'ca-ai-suggestion-dialog',
  standalone: true,
  imports: [
    CaDesignModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule
],
  providers: [],
  templateUrl: './ai-suggestion-dialog.component.html',
  styleUrls: ['./ai-suggestion-dialog.component.scss'],
})
export class AiSuggestionDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AiSuggestionDialogData,
    public translate: TranslateService,
  ) {}

  get hasValidSuggestion(): boolean {
    return (
      !this.data.loading &&
      this.data.error === null &&
      this.data.fields?.every(
        (field) =>
          field.value !== null && field.value !== undefined && field.value.trim().length > 0,
      )
    );
  }
}
